import { render } from "./HeadPanelProject.vue?vue&type=template&id=f65a7bb6"
import script from "./HeadPanelProject.vue?vue&type=script&lang=js"
export * from "./HeadPanelProject.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Projects/creelayer/mosquito/mosquito.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__